import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncImpressum = lazy(() => import('~/containers/Impressum'));

export default [
  <Route path="/impressum">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncImpressum />
    </Suspense>
  </Route>,
];
